import { Component, Input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { FileRules } from 'src/app/model/file.rules';
import { FileRulesCardInfoDialogComponent } from '../file-rules-card-info-dialog/file-rules-card-info-dialog.component';

@Component({
  selector: 'app-track-file-label',
  templateUrl: './track-file-label.component.html',
  styleUrls: ['./track-file-label.component.scss']
})
export class TrackFileLabelComponent {
  @Input() name = '';
  @Input() templateUrl?: string;
  @Input() showColon = false;
  @Input() templateOnly = false;
  @Input() rule?: FileRules;
  @Input() nameClickable = false;

  constructor(private dialog: MatDialog) {}

  openDetailsDialog(): void {
    if (this.rule) {
      this.dialog.open(FileRulesCardInfoDialogComponent, { data: { rule: this.rule } });
    }
  }
}
